<template>
  <div></div>
</template>
<script>
export default {
  mounted() {
    document.getElementById('bars').addEventListener("click", function() {
      const bars = document.getElementById('bars');
      const mobile = document.getElementById('mobile-nav');

      if (bars.classList.contains('active')) {
        bars.classList.remove('active');
        mobile.classList.remove('active');
      } else {
        bars.classList.add('active');
        mobile.classList.add('active');
      }

      if (document.getElementById('nav-mobile').classList.contains('nav-mobile-hide')) {
        document.getElementById('nav-mobile').classList.remove('nav-mobile-hide');
        document.getElementById('nav-mobile').classList.add('nav-mobile-show');
      } else {
        document.getElementById('nav-mobile').classList.remove('nav-mobile-show');
        document.getElementById('nav-mobile').classList.add('nav-mobile-hide');
      }
    });
  }
}
</script>
